import { call, put } from 'redux-saga/effects';

import { deleteSavedFilingPeriodSpreadsheetsFailure } from '@actions/savedFilingPeriod';
import { deleteSpreadsheetSaga } from '@sagas/savedFilingPeriod/deleteSpreadsheetSaga';
import { toastError } from '@store/notifications';

export const deleteSingleSpreadsheetSaga = function* ({ payload }) {
  try {
    yield call(deleteSpreadsheetSaga, { payload });
  } catch (error) {
    const { nonFieldErrors } = error.data || {};

    yield put([
      toastError({
        message: nonFieldErrors || {
          defaultMessage: 'An unexpected error occurred, please try again.',
          id: 'global.notification.api-error-default',
        },
      }),
      deleteSavedFilingPeriodSpreadsheetsFailure(payload),
    ]);
  }
};
